import React from 'react';
import { useTheme } from 'styled-components';
import { ColumnChart } from '../../../CommonComponents/OPL/charts/ColumnChart/ColumnChart';
import { useProjectedIncomeQuery } from '../../api/useProjectedIncomeQuery';
import { ColumnChartLoading } from '../../../CommonComponents/OPL/charts/ColumnChart/ColumnChart.loading';
import { Box } from '../../../CommonComponents/OPL/Box/Box';
import { ErrorState } from '../../../CommonComponents/OPL/AsyncStates/ErrorState/ErrorState';
import { CHART_HEIGHT } from './ProjectedIncomeChart.meta';
import { formatCurrency } from '../../../CommonUtils/formatNumber';
import { useRouteParams } from '../../hooks/useRouteParams';
import { usePeriod } from '../../hooks/usePeriod';

export const ProjectedIncomeChart = () => {
  const { accountId, groupId } = useRouteParams();

  const theme = useTheme();

  const period = usePeriod();

  const { isFetching, isError, refetch, data } = useProjectedIncomeQuery({
    period: period.value,
    startDate: period.dates[0],
    endDate: period.dates[1],
    accountId,
    groupId,
  });

  if (isFetching) {
    return <ColumnChartLoading chartHeight={CHART_HEIGHT} />;
  }

  if (isError) {
    return (
      <Box display="flex" alignItems="center" justifyContent="center" height="100%">
        <ErrorState onAction={refetch} />
      </Box>
    );
  }

  if (!data) {
    return null;
  }

  const series = [
    {
      name: 'Projected Income',
      data: data.chartData.map(({ value }) => value),
    },
  ];

  const categories = data.chartData.map(({ label }) => label);

  return (
    <ColumnChart
      series={series}
      categories={categories}
      yAxisType="currency"
      customSettings={{
        series: [
          {
            color: theme.colors.primary['500'],
          },
        ],
        chart: {
          height: CHART_HEIGHT,
        },
        legend: {
          enabled: false,
        },
        tooltip: {
          shared: true,

          formatter() {
            let tooltip = `
              <span style="font-size: 10px">
                ${(this as any).x}
              </span><table>
            `;

            if ((this as any).points) {
              (this as any).points.forEach(({ y, color, series: { name } }) => {
                tooltip += `
                  <tr>
                    <td>
                      <span style="color:${color}">\u25CF</span> ${name}:
                    </td> 
                    <td>
                      <span style="font-weight: 600">
                        ${formatCurrency(Number(y), { mantissa: 2 })}
                      </span>
                    </td>
                  </tr>
                `;
              });
            }

            return `${tooltip}</table>`;
          },
        },
      }}
    />
  );
};
